if (!customElements.get('conversation-lab-packages')) {
  class ConversationLabPackages extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.conversation-lab-packages__slider');
    }

    get slides() {
      return this.querySelectorAll('.swiper-slide');
    }

    getConfig() {
      return {
        slidesPerView: 1.05,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
          },
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;
      const slideCount = this.slides.length;
      const shouldUseSliderDesktop = slideCount > 3;

      if (isDesktop) {
        if (shouldUseSliderDesktop) {
          if (!this.swiper) {
            this.init();
          }
        } else {
          if (this.swiper) {
            this.destroy();
          }
        }
      } else {
        if (!this.swiper) {
          this.init();
        }
      }
    }

    init() {
      if (this.swiperContainer) {
        this.classList.add('slider-active');
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.classList.remove('slider-active');
    }
  }

  customElements.define('conversation-lab-packages', ConversationLabPackages);
}
